import {
  DeleteOutlined,
  EditOutlined,
  LeftOutlined,
  LeftSquareFilled,
  LogoutOutlined,
  PlusOutlined,
  SearchOutlined,
  UserAddOutlined,
  UserOutlined,
} from "@ant-design/icons";
import React, { useState, useEffect, useRef } from "react";
import AuthService from "../../service/auth-service";
import {
  Button,
  DatePicker,
  Input,
  message,
  Modal,
  Popconfirm,
  Switch,
  Table,
} from "antd";
import Highlighter from "react-highlight-words";
import { useHistory } from "react-router-dom";
import DistrictService from "../../service/district-service";
import { useForm } from "react-hook-form";
import moment from "moment";
import Resizer from "react-image-file-resizer";
import ProfileService from "../../service/profile-service";

const Testimonials = () => {
  const { confirm } = Modal;
  const history = useHistory();
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    setIsLoading(true);
    DistrictService.getAllDistrict()
      .then((res) => {
        if (res?.data?.data?.length) {
          setUsers(res?.data?.data ?? []);
        }
      })
      .finally(() => setIsLoading(false));
  };

  const handleSearch = (selectedKeys, confirm = () => {}, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => {
            setSelectedKeys(e.target.value ? [e.target.value] : []);
          }}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          Search
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const {
    register,
    reset,
    trigger,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      id: null,
      name: "",
    },
  });

  const saveUser = (data) => {
    const payload = {
      name: data?.name,
    };

    DistrictService.addDistrict(payload)
      .then(() => {
        message.success("District saved successfully");
        setShowModal(false);
        fetchUsers();
      })
      .catch((err) => {
        message.error(
          err?.response?.data?.errors[0]?.msg || "Something went wrong"
        );
      });
  };

  const deteteUser = (data) => {
    DistrictService.deleteDistrict(data?.id)
      .then(() => {
        fetchUsers();
        message.success("District deleted successfully");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateUser = (data) => {
    const payload = {
      name: data?.name,
    };

    DistrictService.updateDistrict(data?.id, payload)
      .then(() => {
        setShowModal(false);
        fetchUsers();
        message.success("District updated successfully");
      })
      .catch((err) => {
        message.error(
          err?.response?.data?.errors[0]?.msg || "Something went wrong"
        );
      });
  };

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      ...getColumnSearchProps("id"),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      ...getColumnSearchProps("name"),
    },
    {
      title: "Action",
      align: "center",
      render: (text) => (
        <div>
          <Popconfirm
            title="Are you sure edit this District?"
            okText="Yes"
            cancelText="No"
            placement="left"
            onConfirm={() => {
              setValue("id", text?.id);
              setValue("name", text?.name);
              setShowModal(true);
            }}
          >
            <EditOutlined style={{ marginRight: 10 }} />
          </Popconfirm>
          <Popconfirm
            title="Are you sure delete this District?"
            okText="Yes"
            cancelText="No"
            placement="left"
            onConfirm={() => deteteUser(text)}
          >
            <DeleteOutlined style={{ color: "red" }} />
          </Popconfirm>
        </div>
      ),
    },
  ];

  const handelImageChange = async (e) => {
    const file = e.target.files[0];
    await Resizer.imageFileResizer(
      e.target.files[0],
      1200,
      900,
      "JPEG",
      90,
      0,
      (uri) => {
        handleUpload(uri);
      },
      "base64"
    );
  };

  function base64ToFile(base64String, fileName) {
    const arr = base64String.split(",");
    const mime = arr[0].match(/:(.*?);/)[1]; // Extract MIME type
    const byteString = atob(arr[1]); // Decode base64 string
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uintArray = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uintArray[i] = byteString.charCodeAt(i);
    }

    return new File([uintArray], fileName, { type: mime });
  }

  //Handle Upload
  const handleUpload = (imageData) => {
    message.destroy();
    message.loading("Image Uploading...");
    let name = Math.random().toString().slice(10);
    const file = base64ToFile(imageData, name + ".jpeg");
    const formData = new FormData();
    formData.append("folder", "testimonials");
    formData.append("file", file);
    ProfileService.uploadImage(formData)
      .then((res) => {
        setValue("image_url", res?.data?.url);
        trigger("image_url");
      })
      .catch((e) => console.log(e));
  };

  return (
    <div style={{ padding: 10 }}>
      <div
        style={{
          marginTop: 10,
          marginBottom: 10,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Button
          type="danger"
          onClick={() => {
            history.goBack();
          }}
          icon={<LeftOutlined />}
          size={20}
        >
          Back
        </Button>
        <Button
          type="primary"
          onClick={() => {
            setShowModal(true);
            reset();
          }}
          size={20}
        >
          Add Testimonials
        </Button>
      </div>
      <Table
        dataSource={users}
        columns={columns}
        loading={isLoading}
        pagination={{
          hideOnSinglePage: true,
          showSizeChanger: false,
        }}
      />
      {showModal && (
        <Modal
          title={getValues("id") ? "Update Testimonials" : "Add Testimonials"}
          open={showModal}
          footer={null}
          onCancel={() => {
            setShowModal(false);
            reset();
          }}
        >
          <div style={{ marginBottom: 8 }}>
            <label style={{ marginBottom: 4 }}>Name</label>
            <Input
              {...register("name", {
                required: {
                  value: true,
                  message: "Name is required",
                },
              })}
              value={getValues("name")}
              onChange={(e) => {
                setValue("name", e.target.value);
                trigger("name");
              }}
            />
            <span style={{ color: "red" }}>
              {errors?.name && errors?.name?.message}
            </span>
          </div>
          <div
            style={{
              marginBottom: 8,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <label style={{ marginBottom: 4 }}>Date</label>
            <Input
              width="100%"
              {...register("date", {
                required: {
                  value: true,
                  message: "Date is required",
                },
              })}
              value={getValues("date") ?? null}
              onChange={(e) => {
                setValue("date", e.target.value);
                trigger("date");
              }}
            />
            <span style={{ color: "red" }}>
              {errors?.date && errors?.date?.message}
            </span>
          </div>
          <div style={{ marginBottom: 8 }}>
            <label style={{ marginBottom: 4 }}>Image</label>
            <Input
              type="file"
              accept="image/*"
              multiple={true}
              {...register("image_url", {
                required: {
                  value: true,
                  message: "Image is required",
                },
              })}
              onChange={(e) => handelImageChange(e)}
            />
            <span style={{ color: "red" }}>
              {errors?.image_url && errors?.image_url?.message}
            </span>
          </div>
          <div
            style={{ display: "flex", justifyContent: "center", marginTop: 10 }}
          >
            <Button
              type="primary"
              onClick={() => {
                trigger().then((res) => {
                  if (res) {
                    if (getValues("id")) {
                      updateUser(getValues());
                    } else saveUser(getValues());
                  }
                });
              }}
            >
              {getValues("id") ? "Update" : "Save"}
            </Button>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default Testimonials;
